import { render, staticRenderFns } from "./ListAvatars.vue?vue&type=template&id=72fea47d&"
import script from "./ListAvatars.vue?vue&type=script&lang=js&"
export * from "./ListAvatars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports